import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Channels from '../views/Channels.vue'
import Daily from '../views/Daily.vue'
import Sentence from '../components/Sentence.vue'
import News from '../components/News.vue'
import ModalList from '../components/ModalList.vue'
import Course from '../views/Course.vue'
import FirstLogin from '../views/FirstLogin.vue'
import UpdatedPassword from '../views/UpdatedPassword.vue'
import CourseLesson from '../views/CourseLesson.vue'
import Login from '../views/Login.vue'
import MagLogin from '../views/Mag-Login.vue'
import BiztalkLogin from '../views/Biztalk.vue'
import Personal from '../views/Personal.vue'
import Examination from '../views/Examination.vue'
import ExamArea from '../components/ExamArea.vue'
import Record from '../components/Record.vue'
import Target from '../components/Target.vue'
import Collections from '../components/Collections.vue'
import Raiders from '../views/Toeic/Raiders.vue'
import VocabulariesLayout from '../views/Toeic/Layout.vue'
import Vocabularies from '../views/Toeic/Vocabularies.vue'
import VocabulariesList from '../views/Toeic/VocabulariesList.vue'
import ExamLayout from '../views/Toeic/ExamLayout.vue'
import ToeicExam from '../views/Toeic/Exam.vue'
import EmailLayout from '../views/Email/Layout.vue'
import EmailSentence from '../views/Email/EmailSentence.vue'
import EmailList from '../views/Email/EmailList.vue'
import DetailAnswer from '../views/DetailAnswer.vue'
import Director from '../views/Director/Director.vue'
import Overview from '../views/Director/Overview.vue'
import PersonalDetail from '../views/Director/PersonalDetail.vue'
import Talk from '../views/Talk.vue'
import Search from '../views/Search.vue'
import Writing from '../views/Writing/Layout.vue'
import WritingList from '../views/Writing/WritingList.vue'
import WritingEditor from '../views/Writing/WritingEditor.vue'
import NewsLetter from '../views/NewsLetter.vue'
import Challenge from '../views/Challenge.vue'
import FAQ from '../views/FAQ.vue'
import AiHelperLayout from '../views/AiHelper/Layout.vue'

import Test from '../views/LivePlayer.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/test',
    name: 'Test',
    component: Test,
    meta: { requiresAuth: false }
  },
  {
    path: '/biztalk',
    name: 'Biztalk',
    component: BiztalkLogin,
    meta: { requiresAuth: false }
  },
  {
    path: '/mag',
    name: 'Mag',
    component: MagLogin,
    meta: {
      requiresAuth: false,
      customTitle: 'LiveABC英日語雜誌企業學習網'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ,
    meta: { requiresAuth: false }
  },
  {
    path: '/first-login',
    name: 'First-login',
    component: FirstLogin,
    meta: { requiresAuth: false }
  },
  {
    path: '/reset_password',
    name: 'Reset-password',
    component: UpdatedPassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/updated-password',
    name: 'Updated-password',
    component: UpdatedPassword,
    meta: { requiresAuth: true }
  },
  {
    path: '/daily',
    name: 'Daily',
    component: Daily,
    children: [
      { path: 'sentence', name: 'Sentence', component: Sentence },
      { path: 'news', name: 'News', component: News },
      { path: 'list/:courseId', name: 'modalList', component: ModalList }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/channels/:channel',
    name: 'Channels',
    component: Channels,
    meta: { requiresAuth: true }
  },
  {
    path: '/course/:channel',
    name: 'Course',
    component: Course,
    meta: { requiresAuth: true }
  },
  {
    path: '/course-lesson/:lesson/:courseId',
    name: 'CourseLesson',
    component: CourseLesson,
    meta: { requiresAuth: true }
  },
  {
    path: '/toeic/raiders',
    name: 'Raiders',
    component: Raiders,
    meta: { requiresAuth: true }
  },
  {
    path: '/toeic/vocabularies',
    component: VocabulariesLayout,
    children: [
      { path: '', name: 'Toeic-Vocabularies', component: Vocabularies },
      { path: ':id/:subId', name: 'Toeic-List', component: VocabulariesList }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/ielts/vocabularies',
    // name: 'ielts-Vocabularies',
    component: VocabulariesLayout,
    children: [
      { path: '', name: 'Ielts-Vocabularies', component: Vocabularies },
      { path: ':id/:subId', name: 'Ielts-List', component: VocabulariesList }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/toeic/exam/:channel',
    component: ExamLayout,
    children: [
      { path: ':id?', name: 'Topic-Exam', component: ToeicExam }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/biz-talk',
    name: 'Biz-talk',
    component: Talk,
    meta: { requiresAuth: true }
  },
  {
    path: '/newsletter',
    name: 'NewsLetter',
    component: NewsLetter,
    meta: { requiresAuth: true }
  },
  {
    path: '/writing',
    component: Writing,
    children: [
      { path: '', name: 'WritingList', component: WritingList },
      { path: 'editor/:id', name: 'WritingEditor', component: WritingEditor }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/email/Sentence',
    component: EmailLayout,
    children: [
      { path: '', name: 'Email-Sentence', component: EmailSentence },
      { path: ':id/:subId', name: 'Email-list', component: EmailList }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/personal',
    name: 'Personal',
    component: Personal,
    meta: { requiresAuth: true },
    children: [
      { path: 'target', name: 'Target', component: Target },
      { path: 'collections', name: 'Collections', component: Collections },
      { path: 'exam', name: 'Exam-area', component: ExamArea },
      { path: 'record', name: 'Record', component: Record }
    ]
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    props: route => ({ query: route.query.q }),
    meta: { requiresAuth: true }
  },
  {
    path: '/challenge',
    name: 'Challenge',
    component: Challenge,
    meta: { requiresAuth: true }
  },
  {
    path: '/examination/:examId/:viewId',
    name: 'Examination',
    component: Examination,
    meta: { requiresAuth: true }
  },
  {
    path: '/detailAnswer/:examId/:viewId/:recordId?',
    name: 'DetailAnswer',
    component: DetailAnswer,
    meta: { requiresAuth: true }
  },
  {
    path: '/director',
    name: 'Director',
    component: Director,
    children: [
      { path: 'overview/:type/:groupId?', name: 'Overview', component: Overview },
      { path: 'personal-detail/:type/:groupId?', name: 'PersonalDetail', component: PersonalDetail }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    component: () => import('@/views/AiHelper/course/Layout.vue'),
    children: [
      { path: 'ai_course/:lesson/:courseId', name: 'ai_course', component: () => import('@/views/AiHelper/course/Corse') },
      { path: 'chat/:lesson/:promptId?', name: 'course_chat', component: () => import('@/views/AiHelper/ChatContent.vue') }
    ],
    meta: { requiresAuth: true, hideHeader: false }
  },
  { path: '/AI', name: 'AI_Home', component: () => import('@/views/AiHelper/Home.vue'), meta: { requiresAuth: true, hideHeader: false } },
  { path: '/AI/records', name: 'ai_records', component: () => import('@/views/AiHelper/Records.vue'), hideHeader: false },
  {
    path: '/AI_assistant',
    name: 'AI_assistant',
    component: AiHelperLayout,
    meta: { requiresAuth: true, hideHeader: false },
    children: [
      { path: 'intro', name: 'ai_assistantIntro', component: () => import('@/views/AiHelper/Intro.vue') },
      { path: 'generate/:aiType', name: 'ai_assistantMain', component: () => import('@/views/AiHelper/Speech.vue') },
      { path: 'generate/correction/:aiType', name: 'ai_assistant_correction', component: () => import('@/views/AiHelper/Speech.vue') },
      { path: 'generate/follow/:aiType', name: 'ai_assistant_follow', component: () => import('@/views/AiHelper/Speech.vue') },
      { path: 'generate/view/:aiType/:promptId?/:generateType?', name: 'viewGenerate', component: () => import('@/views/AiHelper/Speech.vue') },
      { path: 'chat/:promptId?', name: 'chat', component: () => import('@/views/AiHelper/ChatContent.vue') },
      { path: 'chat_history', name: 'chat_history', component: () => import('@/views/AiHelper/ChatHistory.vue') },
      { path: 'view/:lang', name: 'viewChat', component: () => import('@/views/AiHelper/ChatContent.vue') },
      { path: 'conversation_rating', name: 'conversation_rating', component: () => import('@/views/AiHelper/ChatRate.vue') },
      { path: 'records', name: 'records', component: () => import('@/views/AiHelper/Records.vue') }
    ]
  },
  {
    path: '/toeic_examination',
    name: 'TOEICEXAM',
    component: () => import('@/views/AiHelper/TOEIC/Layout.vue'),
    meta: { requiresAuth: true, hideHeader: true },
    children: [
      { path: 'list/:exam_type', name: 'TOEIC_list', component: () => import('@/views/AiHelper/TOEIC/List.vue') },
      { path: 'exam/:practice_type/:exam_id', name: 'TOEIC_exam', component: () => import('@/views/AiHelper/TOEIC/Practice.vue') },
      { path: 'exam/bridge/:practice_type/:exam_id', name: 'TOEIC_bridge', component: () => import('@/views/AiHelper/TOEIC/Practice.vue') },
      { path: 'report/:practice_type/:record_id', name: 'TOEIC_report', component: () => import('@/views/AiHelper/TOEIC/Report.vue') },
      { path: 'detailed_explanation/:record_id?', name: 'detailed_explanation', component: () => import('@/views/AiHelper/TOEIC/detailed_explanation.vue') }
    ]
  },
  { path: '*', redirect: { name: 'Home' } }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async function (to, from, next) {
  const defaultTitle = 'LiveLearning Pro'
  if (to.meta.customTitle) {
    document.title = to.meta.customTitle
  } else if (store.state.magOnly === true || store.state.magEnable === true) {
    document.title = 'LiveABC英日語雜誌企業學習網'
  } else {
    document.title = defaultTitle
  }
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)
  if (to.name === 'Reset-password' && store.getters.authorized) {
    try {
      await store.dispatch('logout')
    } catch (error) {
      store.commit('logout')
    }
  }
  next()
})
export default router
